import _ from "lodash";
import { REACT_APP_BASE_URL } from "resources/constants";

export const parseFiltersToQueryParamsWithUnderscore = (filters) => {
  const queryParams = [];

  _.map(filters, (value, key) => {
    if (value !== "")
      queryParams.push(
        _.has(value, "id") ? `${key}_id=${value.id}` : `${key}=${value}`
      );
  });

  return queryParams;
};

export const setNullFilterWhenEmpty = (filters) => {
  let cleanFilters = {};

  _.forOwn(filters, (value, key) => {
    if (value !== "" && value !== undefined)
      cleanFilters = {
        ...cleanFilters,
        [key]: value,
      };
    else
      cleanFilters = {
        ...cleanFilters,
        [key]: { id: null },
      };
  });

  return cleanFilters;
};

const buildRequestUrl = (
  parameters = {},
  endpoint,
  baseUrl = REACT_APP_BASE_URL
) => {
  let url = `${baseUrl}/${endpoint}`;

  if (parameters.path) {
    url += `/${parameters.path}`;
  }

  url += "?";

  if (parameters.filters) {
    const queryParams = parseFiltersToQueryParamsWithUnderscore(
      parameters.filters
    );
    url += `${queryParams.join("&")}`;
  }

  _.forEach(parameters, (value, key) => {
    if (key !== "filters" && key !== "path") url += `&${key}=${value}`;
  });

  return url;
};

export default buildRequestUrl;
